import Settings from "./Settings";
import MainPage from "../templatePage/templatePage";

const SettingsPage = () => {
  return <MainPage component={<Settings />} />;
};

export default SettingsPage;